import { render, staticRenderFns } from "./ProfileWizardTab.vue?vue&type=template&id=335b7d86"
import script from "./ProfileWizardTab.vue?vue&type=script&lang=js"
export * from "./ProfileWizardTab.vue?vue&type=script&lang=js"
import style0 from "./ProfileWizardTab.vue?vue&type=style&index=0&id=335b7d86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports